import JourneyPeding from './Peding';
import JourneyCurrent from './Current';
import { IJourneyResp, ISchedules } from '../../../services/journey.service';

export interface JourneyActionVariant {
  variant: 'pending' | 'current';
  journey?: IJourneyResp;
}

export interface JourneyActionPayload {
  journey: IJourneyResp;
}

export const getCurrentSchedule = (journey: IJourneyResp): ISchedules | undefined => {
  const schedules = journey.schedules?.filter(schedule => schedule.dateStart) ?? [];
  if (schedules.length <= 0) return;

  const upcomingSchedules = schedules
    .filter(
      schedule => schedule.status === 'SCHEDULED' && schedule.dateEnd && schedule.dateEnd > new Date().toISOString()
    )
    .sort((a, b) => new Date(a.dateStart).getTime() - new Date(b.dateStart).getTime());
  if (upcomingSchedules.length > 0) return upcomingSchedules[0];

  const pastScheduled = schedules
    .filter(schedule => schedule.status === 'SCHEDULED')
    .sort((a, b) => new Date(b.dateStart).getTime() - new Date(a.dateStart).getTime());

  return pastScheduled[0];
};

const JourneyActionManager = ({ variant, journey }: JourneyActionVariant) => {
  if (variant === 'pending') {
    if (!journey) return null;
    return <JourneyPeding journey={journey} />;
  }
  if (variant === 'current') {
    return <JourneyCurrent />;
  }
  return <></>;
};

export default JourneyActionManager;
